import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth-context";
import { useBalance } from "@/lib/balance-context";
import { Button } from "@/components/ui/button";
import { LogOut, Lock, Ticket } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const balanceCtx = useBalance();
  const balance = balanceCtx?.balance;
  const location = useLocation();
  const isPublic = location.pathname.startsWith("/verify") || location.pathname.startsWith("/watch");

  const totalCredits = balance?.credits?.total ?? null;

  return (
    <header className="glass sticky top-0 z-40" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <Link to={user ? "/dashboard" : "/"} className="flex items-center gap-3 group" data-testid="brand-link">
          <div className="w-8 h-8 border border-terracotta/50 flex items-center justify-center rounded-sm">
            <Lock className="w-3.5 h-3.5 text-terracotta" strokeWidth={1.5} />
          </div>
          <div className="leading-none">
            <div className="font-serif text-xl tracking-tight text-bone">ChronoVaults</div>
            <div className="label-mono mt-1 text-[9px]">Sealed · Delayed · Delivered</div>
          </div>
        </Link>

        {isPublic ? null : (
          <nav className="flex items-center gap-2">
            {user ? (
              <>
                {totalCredits !== null && (
                  <Link to="/pricing" data-testid="credit-chip" className="hidden sm:flex items-center gap-2 px-3 py-1.5 border border-white/10 hover:border-terracotta/40 text-xs text-white/70 hover:text-bone transition-colors">
                    <Ticket className="w-3.5 h-3.5 text-terracotta" strokeWidth={1.5} />
                    <span data-testid="credit-count">{totalCredits}</span>
                    <span className="text-white/40">{totalCredits === 1 ? "message" : "messages"}</span>
                  </Link>
                )}
                <Link to="/dashboard" data-testid="nav-dashboard">
                  <Button variant="ghost" className="text-bone/80 hover:text-bone">Dashboard</Button>
                </Link>
                {user?.is_admin && !user?.is_demo ? (
                  <Link to="/admin" data-testid="nav-admin">
                    <Button variant="ghost" className="text-terracotta hover:text-terracotta/80 label-mono text-[11px]">
                      Admin
                    </Button>
                  </Link>
                ) : null}
                <Link to="/capsules/new" data-testid="nav-new-capsule">
                  <Button className="bg-terracotta hover:bg-terracotta/90 text-white rounded-full px-5">New Capsule</Button>
                </Link>
                <Button onClick={logout} variant="ghost" size="icon" data-testid="logout-btn" className="text-bone/60 hover:text-bone">
                  <LogOut className="w-4 h-4" />
                </Button>
              </>
            ) : (
              <>
                <Link to="/login" data-testid="nav-login">
                  <Button variant="ghost" className="text-bone/70 hover:text-bone">Sign in</Button>
                </Link>
                <Link to="/register" data-testid="nav-register">
                  <Button className="bg-terracotta hover:bg-terracotta/90 text-white rounded-full px-5">Begin sealing</Button>
                </Link>
              </>
            )}
          </nav>
        )}
      </div>
    </header>
  );
}
